<template>
  <div class="page-wrapper">
    <div class="content container-fluid">
      <!-- Page Header -->
      <div class="page-header">
        <div class="row align-items-center">
          <div class="col">
            <h3 class="page-title mb-1">Quản lý Phiếu Thu Chi</h3>
            <ul class="breadcrumb mb-0">
              <li class="breadcrumb-item"><a href="/">Dashboard</a></li>
              <li class="breadcrumb-item active">Thu Chi - Danh sách</li>
            </ul>
          </div>
          <div class="col-auto mt-3 mt-md-0">
            <button class="btn btn-white mr-2" @click="onResetFilters">
              <i class="fa fa-eraser mr-1" /> Xóa lọc
            </button>
            <button class="btn btn-primary" @click="onSearch">
              <i class="fa fa-search mr-1" /> Tìm kiếm
            </button>
          </div>
        </div>
      </div>
      <!-- /Page Header -->

      <!-- Bộ lọc -->
      <div class="card mb-3">
        <div class="card-body">
          <div class="row filter-row">
            <div class="col-12 col-md-4 col-lg-3 mb-2">
              <label class="form-label">Từ khóa</label>
              <input
                v-model="filters.keyword"
                type="text"
                class="form-control"
                placeholder="Nhân viên, ghi chú, mã phiếu..."
              />
            </div>
            <div class="col-6 col-md-2 col-lg-2 mb-2">
              <label class="form-label">Loại</label>
              <select v-model="filters.loai" class="form-control">
                <option value="">Tất cả</option>
                <option value="CHI">Chi (NV bỏ tiền)</option>
                <option value="THU">Thu (Tạm ứng/Thu hộ)</option>
              </select>
            </div>
            <div class="col-6 col-md-2 col-lg-2 mb-2">
              <label class="form-label">Trạng thái</label>
              <select v-model="filters.trangThai" class="form-control">
                <option value="">Tất cả</option>
                <option value="CHO_DUYET">Chờ duyệt</option>
                <option value="DA_DUYET">Đã duyệt</option>
                <option value="DA_THANH_TOAN">Đã thanh toán</option>
                <option value="DA_QUYET_TOAN">Đã quyết toán lương</option>
                <option value="TU_CHOI">Từ chối</option>
              </select>
            </div>

            <div class="col-6 col-md-3 col-lg-2 mb-2">
              <label class="form-label">Từ ngày</label>
              <input
                v-model="filters.tuNgay"
                type="date"
                class="form-control"
              />
            </div>
            <div class="col-6 col-md-3 col-lg-2 mb-2">
              <label class="form-label">Đến ngày</label>
              <input
                v-model="filters.denNgay"
                type="date"
                class="form-control"
              />
            </div>
            <div class="col-12 col-md-4 col-lg-3 mb-2">
              <label class="form-label">Hướng xử lý</label>
              <select v-model="filters.huongXuLy" class="form-control">
                <option value="">Tất cả</option>
                <option value="QUA_LUONG">Qua lương (Cty nợ NV)</option>
                <option value="TRA_NONG">Trả nóng (Cty trả ngay)</option>
                <option value="TRU_LUONG">Trừ lương (NV nợ cty)</option>
                <option value="NOP_NGAY">Nộp lại ngay</option>
              </select>
            </div>

            <div class="col-12 col-md-4 col-lg-3 mb-2">
              <label class="form-label">Nhân viên</label>
              <select v-model="filters.idNguoiDung" class="form-control">
                <option :value="null">Tất cả nhân viên</option>
                <option
                  v-for="u in nguoiDungOptions"
                  :key="u.idNguoiDung"
                  :value="u.idNguoiDung"
                >
                  {{ u.hoTen || u.tenDangNhap }}
                </option>
              </select>
            </div>

            <div class="col-12 col-md-4 col-lg-3 mb-2">
              <label class="form-label">Danh mục</label>
              <select v-model="filters.idDanhMuc" class="form-control">
                <option :value="null">Tất cả danh mục</option>
                <option
                  v-for="dm in danhMucFilterOptions"
                  :key="dm.idDanhMuc"
                  :value="dm.idDanhMuc"
                >
                  {{ dm.tenDanhMuc }}
                </option>
              </select>
            </div>

            <div class="col-12 col-md-2 col-lg-2 mb-2">
              <label class="form-label">Kích thước trang</label>
              <select v-model.number="pageInfo.size" class="form-control">
                <option :value="10">10</option>
                <option :value="20">20</option>
                <option :value="50">50</option>
              </select>
            </div>
          </div>
        </div>
      </div>

      <!-- Summary nhỏ trên đầu bảng -->
      <div class="row mb-2">
        <div class="col-12 col-lg-4 mb-2">
          <div class="card mini-stat bg-light h-100">
            <div class="card-body d-flex flex-column">
              <div class="d-flex justify-content-between align-items-center mb-1">
                <span class="text-muted small">Số phiếu trên trang</span>
                <i class="fa fa-file-text-o text-secondary" />
              </div>
              <h4 class="mb-1">{{ items.length }}</h4>
              <small class="text-muted mt-auto">
                Tổng phiếu: {{ pageInfo.totalElements }}
              </small>
            </div>
          </div>
        </div>
        <div class="col-6 col-lg-4 mb-2">
          <div class="card mini-stat bg-soft-danger h-100">
            <div class="card-body d-flex flex-column">
              <div class="d-flex justify-content-between align-items-center mb-1">
                <span class="text-muted small">Tổng Chi trên trang</span>
                <i class="fa fa-arrow-down text-danger" />
              </div>
              <h4 class="mb-1">{{ formatCurrency(pageSummary.tongChi) }}</h4>
              <small class="text-muted mt-auto">
                Chỉ tính các phiếu loại CHI trong bảng
              </small>
            </div>
          </div>
        </div>
        <div class="col-6 col-lg-4 mb-2">
          <div class="card mini-stat bg-soft-success h-100">
            <div class="card-body d-flex flex-column">
              <div class="d-flex justify-content-between align-items-center mb-1">
                <span class="text-muted small">Tổng Thu trên trang</span>
                <i class="fa fa-arrow-up text-success" />
              </div>
              <h4 class="mb-1">{{ formatCurrency(pageSummary.tongThu) }}</h4>
              <small class="text-muted mt-auto">
                Chỉ tính các phiếu loại THU trong bảng
              </small>
            </div>
          </div>
        </div>
      </div>

      <!-- Bảng danh sách -->
      <div class="card">
        <div class="card-body table-responsive">
          <div v-if="loading.list" class="mb-2">
            <span class="spinner-border spinner-border-sm mr-2" role="status"></span>
            Đang tải danh sách phiếu...
          </div>
          <table class="table table-hover table-sm mb-0">
            <thead>
              <tr>
                <th>Ngày</th>
                <th>Loại</th>
                <th>Danh mục</th>
                <th class="text-right">Số tiền</th>
                <th>Nhân viên</th>
                <th>Trạng thái</th>
                <th>Hướng xử lý</th>
                <th class="text-right">Thao tác</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="!items.length && !loading.list">
                <td colspan="9" class="text-center text-muted small">
                  Chưa có phiếu nào phù hợp bộ lọc.
                </td>
              </tr>
              <tr v-for="item in items" :key="item.id">
                <td>{{ formatDate(item.ngayGiaoDich) }}</td>
                <td>
                  <span
                    class="badge"
                    :class="item.loai === 'CHI' ? 'badge-danger' : 'badge-success'"
                  >
                    {{ item.loai === 'CHI' ? 'CHI' : 'THU' }}
                  </span>
                </td>
                <td>
                  <div class="d-flex align-items-center">
                    <img
                      v-if="item.iconDanhMucUrl"
                      :src="item.iconDanhMucUrl"
                      alt="icon"
                      class="rounded-circle mr-1"
                      style="width: 20px; height: 20px; object-fit: cover;"
                    />
                    <span class="text-truncate" style="max-width: 180px;">
                      {{ item.tenDanhMuc || '-' }}
                    </span>
                  </div>
                </td>
                <td class="text-right">
                  {{ formatCurrency(item.soTien) }}
                </td>
                <td>
                  <span class="text-truncate" style="max-width: 140px;">
                    {{ item.tenNguoiTao || item.hoTenNguoiTao || '-' }}
                  </span>
                </td>

                <td>
                  <span :class="['badge', badgeTrangThaiClass(item.trangThai)]">
                    {{ labelTrangThai(item.trangThai) }}
                  </span>
                </td>
                <td>
                  <span
                    v-if="item.huongXuLy"
                    :class="['badge', badgeHuongXuLyClass(item.huongXuLy)]"
                  >
                    {{ labelHuongXuLy(item.huongXuLy, item.loai) }}
                  </span>
                  <span v-else class="badge badge-light">Chưa chọn</span>
                </td>
                <td class="text-right">
                  <button
                    class="btn btn-sm btn-white mr-1"
                    @click="openDetail(item)"
                  >
                    <i class="fa fa-eye mr-1" /> Xem
                  </button>
                </td>
              </tr>
            </tbody>
          </table>

          <!-- Pagination -->
          <div class="d-flex justify-content-between align-items-center mt-2 flex-column flex-md-row">
            <div class="mb-2 mb-md-0 small text-muted">
              Trang {{ pageInfo.page + 1 }} / {{ pageInfo.totalPages || 1 }},
              tổng {{ pageInfo.totalElements }} phiếu
            </div>
            <div>
              <button
                class="btn btn-sm btn-white mr-1"
                :disabled="pageInfo.page === 0 || loading.list"
                @click="changePage(pageInfo.page - 1)"
              >
                <i class="fa fa-chevron-left" />
              </button>
              <button
                class="btn btn-sm btn-white"
                :disabled="pageInfo.page >= pageInfo.totalPages - 1 || loading.list"
                @click="changePage(pageInfo.page + 1)"
              >
                <i class="fa fa-chevron-right" />
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Backdrop modal -->
      <div v-if="showDetailModal" class="modal-backdrop fade show" />

      <!-- Modal chi tiết phiếu -->
      <div
        :class="['modal', 'fade', { show: showDetailModal }]"
        tabindex="-1"
        role="dialog"
        style="display: block;"
        v-if="showDetailModal"
      >
        <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-xl" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <div>
                <h5 class="modal-title mb-0">
                  Chi tiết phiếu Thu Chi
                  <span
                    v-if="detail.loai"
                    :class="['badge ml-2', detail.loai === 'CHI' ? 'badge-danger' : 'badge-success']"
                  >
                    {{ detail.loai === 'CHI' ? 'CHI - Nhân viên bỏ tiền' : 'THU - Tạm ứng/Thu hộ' }}
                  </span>
                </h5>
                <small class="text-muted">
                  ID: {{ detail.id || '-' }} · Ngày: {{ formatDate(detail.ngayGiaoDich) || '-' }}
                </small>
              </div>
              <button type="button" class="close" @click="closeDetail">
                <span>&times;</span>
              </button>
            </div>

            <div class="modal-body">
              <div v-if="loading.detail" class="mb-2">
                <span class="spinner-border spinner-border-sm mr-2" role="status"></span>
                Đang tải chi tiết phiếu...
              </div>

              <div v-if="!loading.detail">
                <div class="row">
                  <!-- Thông tin cơ bản -->
                  <div class="col-12 col-lg-6 mb-3">
                    <div class="card border">
                      <div class="card-header py-2">
                        <h6 class="mb-0">Thông tin phiếu</h6>
                      </div>
                      <div class="card-body py-2">
                        <div class="row">
                          <div class="col-6 mb-2">
                            <div class="text-muted small">Nhân viên tạo</div>
                            <div>{{ detail.tenNguoiTao || '-' }}</div>
                          </div>
                          <div class="col-6 mb-2">
                            <div class="text-muted small">Người duyệt</div>
                            <div>{{ detail.tenNguoiDuyet || '-' }}</div>
                          </div>
                          <div class="col-6 mb-2">
                            <div class="text-muted small">Ngày duyệt</div>
                            <div>{{ formatDate(detail.ngayDuyet) || '-' }}</div>
                          </div>
                          <div class="col-6 mb-2">
                            <div class="text-muted small">Hình thức</div>
                            <div>
                              <span class="badge badge-secondary">
                                {{ formatHinhThuc(detail.hinhThuc) }}
                              </span>
                            </div>
                          </div>
                          <div class="col-6 mb-2">
                            <div class="text-muted small">Danh mục</div>
                            <div>{{ detail.tenDanhMuc || '-' }}</div>
                          </div>
                          <div class="col-6 mb-2">
                            <div class="text-muted small">Số tiền gốc</div>
                            <div class="font-weight-bold">
                              {{ formatCurrency(detail.soTien) }}
                            </div>
                          </div>

                          <div class="col-6 mb-2" v-if="detail.soTienThucTe">
                            <div class="text-muted small">Số tiền thực tế</div>
                            <div class="font-weight-bold">
                              {{ formatCurrency(detail.soTienThucTe) }}
                            </div>
                          </div>

                          <div class="col-6 mb-2">
                            <div class="text-muted small">Trạng thái</div>
                            <div>
                              <span
                                :class="['badge', badgeTrangThaiClass(detail.trangThai)]"
                              >
                                {{ labelTrangThai(detail.trangThai) }}
                              </span>
                            </div>
                          </div>
                          <div class="col-6 mb-2">
                            <div class="text-muted small">Hướng xử lý</div>
                            <div>
                              <span
                                v-if="detail.huongXuLy"
                                :class="['badge', badgeHuongXuLyClass(detail.huongXuLy)]"
                              >
                                {{ labelHuongXuLy(detail.huongXuLy, detail.loai) }}
                              </span>
                              <span v-else class="badge badge-light">Chưa chọn</span>
                            </div>
                          </div>

                          <div class="col-12 mb-2">
                            <div class="text-muted small">Ghi chú</div>
                            <div>{{ detail.ghiChu || '-' }}</div>
                          </div>

                          <div class="col-12 mb-2" v-if="detail.lyDoTuChoi">
                            <div class="text-muted small">Lý do từ chối</div>
                            <div class="text-danger">{{ detail.lyDoTuChoi }}</div>
                          </div>

                          <div class="col-12 mb-2" v-if="detail.ghiChuThanhToan">
                            <div class="text-muted small">Ghi chú thanh toán</div>
                            <div>{{ detail.ghiChuThanhToan }}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Ảnh & hoạt động -->
                  <div class="col-12 col-lg-6 mb-3">
                    <div class="card border mb-3">
                      <div class="card-header py-2 d-flex justify-content-between align-items-center">
                        <h6 class="mb-0">Ảnh hóa đơn / chứng từ</h6>
                        <span class="badge badge-light">{{ hoaDonImages.length }} ảnh</span>
                      </div>
                      <div class="card-body py-2">
                        <div v-if="hoaDonImages.length === 0" class="text-muted small">
                          Không có ảnh hóa đơn.
                        </div>
                        <div
                          class="d-flex flex-wrap align-items-center"
                          v-else
                        >
                          <div
                            v-for="(url, idx) in hoaDonImages"
                            :key="idx"
                            class="mr-2 mb-2 position-relative"
                          >
                            <img
                              :src="url"
                              alt="Hóa đơn"
                              class="rounded border"
                              style="width: 72px; height: 72px; object-fit: cover; cursor: zoom-in;"
                              @click="openLightbox(url)"
                            />
                            <span 
                              v-if="detail.dsAnhHoaDon && detail.dsAnhHoaDon[idx]?.isMain"
                              class="badge badge-primary badge-sm position-absolute"
                              style="top: 2px; right: 2px; font-size: 0.6rem;"
                            >
                              Chính
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="card border">
                      <div class="card-header py-2 d-flex justify-content-between align-items-center">
                        <h6 class="mb-0">Ảnh thanh toán / nộp lại</h6>
                        <span class="badge badge-light">{{ thanhToanImages.length }} ảnh</span>
                      </div>
                      <div class="card-body py-2">
                        <div v-if="thanhToanImages.length === 0" class="text-muted small">
                          Chưa có ảnh xác nhận thanh toán.
                        </div>
                        <div
                          class="d-flex flex-wrap align-items-center"
                          v-else
                        >
                          <div
                            v-for="(url, idx) in thanhToanImages"
                            :key="'tt-' + idx"
                            class="mr-2 mb-2"
                          >
                            <img
                              :src="url"
                              alt="Thanh toán"
                              class="rounded border"
                              style="width: 72px; height: 72px; object-fit: cover; cursor: zoom-in;"
                              @click="openLightbox(url)"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Hành động quản lý -->
                <div class="row mt-2">
                  <!-- Duyệt / Từ chối -->
                  <div class="col-12 col-lg-4 mb-3">
                    <div class="card border">
                      <div class="card-header py-2">
                        <h6 class="mb-0">Duyệt / Từ chối</h6>
                      </div>
                      <div class="card-body py-2">
                        <p class="small text-muted mb-1">
                          Áp dụng khi phiếu đang ở trạng thái
                          <span class="badge badge-warning">Chờ duyệt</span>.
                        </p>

                        <div class="form-group mb-2">
                          <label class="small">Lý do từ chối (nếu từ chối)</label>
                          <textarea
                            v-model="duyetForm.lyDoTuChoi"
                            class="form-control"
                            rows="2"
                            placeholder="Nhập lý do nếu từ chối..."
                          ></textarea>
                        </div>

                        <div class="d-flex">
                          <button
                            class="btn btn-success btn-sm mr-2"
                            :disabled="!canDuyet || actionLoading.duyet"
                            @click="onDuyet(true)"
                          >
                            <span
                              v-if="actionLoading.duyet && duyetForm.lastActionApprove"
                              class="spinner-border spinner-border-sm mr-1"
                            ></span>
                            <i v-else class="fa fa-check mr-1"></i>
                            Duyệt
                          </button>
                          <button
                            class="btn btn-danger btn-sm"
                            :disabled="!canDuyet || actionLoading.duyet"
                            @click="onDuyet(false)"
                          >
                            <span
                              v-if="actionLoading.duyet && !duyetForm.lastActionApprove"
                              class="spinner-border spinner-border-sm mr-1"
                            ></span>
                            <i v-else class="fa fa-times mr-1"></i>
                            Từ chối
                          </button>
                        </div>
                        <p class="small text-muted mt-2 mb-0">
                          Trạng thái hiện tại:
                          <span
                            :class="['badge', badgeTrangThaiClass(detail.trangThai)]"
                          >
                            {{ labelTrangThai(detail.trangThai) }}
                          </span>
                        </p>
                      </div>
                    </div>
                  </div>

                  <!-- Hướng xử lý -->
                  <div class="col-12 col-lg-4 mb-3">
                    <div class="card border">
                      <div class="card-header py-2">
                        <h6 class="mb-0">Chọn hướng xử lý</h6>
                      </div>
                      <div class="card-body py-2">
                        <p class="small text-muted mb-1">
                          Chỉ áp dụng khi phiếu
                          <span class="badge badge-info">Đã duyệt</span>.
                        </p>

                        <div class="form-group mb-2">
                          <label class="small">Hướng xử lý</label>
                          <select
                            v-model="huongXuLyForm.huongXuLy"
                            class="form-control"
                            :disabled="!canDatHuongXuLy || actionLoading.huongXuLy"
                          >
                            <option value="">-- Chọn --</option>
                            <option
                              v-for="opt in huongXuLyOptionsForDetail"
                              :key="opt.value"
                              :value="opt.value"
                            >
                              {{ opt.label }}
                            </option>
                          </select>
                        </div>

                        <button
                          class="btn btn-primary btn-sm"
                          :disabled="!canDatHuongXuLy || !huongXuLyForm.huongXuLy || actionLoading.huongXuLy"
                          @click="onDatHuongXuLy"
                        >
                          <span
                            v-if="actionLoading.huongXuLy"
                            class="spinner-border spinner-border-sm mr-1"
                          ></span>
                          <i v-else class="fa fa-save mr-1"></i>
                          Lưu hướng xử lý
                        </button>
                        <p class="small text-muted mt-2 mb-0">
                          Hướng hiện tại:
                          <span v-if="detail.huongXuLy" :class="['badge', badgeHuongXuLyClass(detail.huongXuLy)]">
                            {{ labelHuongXuLy(detail.huongXuLy, detail.loai) }}
                          </span>
                          <span v-else class="badge badge-light">Chưa chọn</span>
                        </p>
                      </div>
                    </div>
                  </div>

                  <!-- Thanh toán nóng / Nộp lại ngay -->
                  <div class="col-12 col-lg-4 mb-3">
                    <div class="card border">
                      <div class="card-header py-2">
                        <h6 class="mb-0">
                          {{ detail.loai === 'CHI' ? 'Xác nhận trả nóng' : 'Xác nhận nộp lại ngay' }}
                        </h6>
                      </div>
                      <div class="card-body py-2">
                        <p class="small text-muted mb-1">
                          Áp dụng khi phiếu
                          <span class="badge badge-info">Đã duyệt</span>
                          và đã chọn hướng xử lý phù hợp
                          (<span class="badge badge-info">Trả nóng / Nộp ngay</span>).
                        </p>

                        <div v-if="!canThanhToanNgay" class="alert alert-light border small py-2 mb-2">
                          Không thể thanh toán / nộp ngay ở trạng thái hiện tại.
                        </div>

                        <div v-else>
                          <div class="form-group mb-2">
                            <label class="small">Số tiền thanh toán / nộp lại</label>
                            <input
                              v-model.number="thanhToanForm.soTienThucTe"
                              type="number"
                              class="form-control"
                              min="0"
                            />
                            <small class="text-muted">
                              Để trống sẽ mặc định bằng số tiền phiếu.
                            </small>
                          </div>

                          <div class="form-group mb-2">
                            <label class="small">Hình thức thanh toán</label>
                            <select
                              v-model="thanhToanForm.hinhThucThanhToan"
                              class="form-control"
                            >
                              <option disabled value="">-- Chọn --</option>
                              <option value="CHUYEN_KHOAN">Chuyển khoản</option>
                              <option value="TIEN_MAT">Tiền mặt</option>
                            </select>
                          </div>

                          <div class="form-group mb-2">
                            <label class="small">Ghi chú</label>
                            <textarea
                              v-model="thanhToanForm.ghiChu"
                              class="form-control"
                              rows="2"
                              placeholder="Ví dụ: Đã chuyển khoản, Mã giao dịch..."
                            ></textarea>
                          </div>

                          <div class="form-group mb-2">
                            <label class="small">Ảnh xác nhận (nhiều ảnh)</label>
                            <input
                              type="file"
                              class="form-control-file"
                              multiple
                              @change="onFilesChange"
                            />
                            <div
                              v-if="thanhToanForm.files && thanhToanForm.files.length"
                              class="small text-muted mt-1"
                            >
                              {{ thanhToanForm.files.length }} file đã chọn
                            </div>
                          </div>

                          <button
                            class="btn btn-success btn-sm"
                            :disabled="!canThanhToanNgay || actionLoading.thanhToan"
                            @click="onThanhToanNgay"
                          >
                            <span
                              v-if="actionLoading.thanhToan"
                              class="spinner-border spinner-border-sm mr-1"
                            ></span>
                            <i v-else class="fa fa-money mr-1"></i>
                            Xác nhận {{ detail.loai === 'CHI' ? 'trả nóng' : 'nộp lại' }}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Ghi chú quy trình -->
                <p class="small text-muted mt-1 mb-0">
                  Quy trình:
                  <strong>CHI</strong> · NV bỏ tiền → Chờ duyệt → Đã duyệt (Cty nợ NV) →
                  Qua lương / Trả nóng →
                  Quyết toán lương / Đã thanh toán.
                  &nbsp;|&nbsp;
                  <strong>THU</strong> · NV nhận tiền → Chờ duyệt → Đã duyệt (NV nợ Cty) →
                  Trừ lương / Nộp ngay →
                  Quyết toán lương / Đã nộp lại.
                </p>
              </div>
            </div>

            <div class="modal-footer">
              <button class="btn btn-secondary" @click="closeDetail">
                Đóng
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Lightbox ảnh -->
      <vue-easy-lightbox
        v-if="lightbox.visible"
        :visible="lightbox.visible"
        :imgs="lightbox.imgs"
        :index="lightbox.index"
        @hide="lightbox.visible = false"
      />
    </div>
  </div>
</template>

<script setup>
import {
  ref,
  reactive,
  computed,
  onMounted,
} from "vue";
import api from "@/api/index.js";
import { useToast } from "vue-toastification";
import VueEasyLightbox from "vue-easy-lightbox";

const toast = useToast();

/* ---------------------- Bộ lọc & dữ liệu bảng ---------------------- */

const filters = reactive({
  keyword: "",
  loai: "",
  trangThai: "",
  huongXuLy: "",
  tuNgay: "",
  denNgay: "",
  idPhongBan: null,
  idNguoiDung: null,
  idDanhMuc: null,
});

const items = ref([]);
const phongBanOptions = ref([]);
const nguoiDungOptions = ref([]);
const danhMucChi = ref([]);
const danhMucThu = ref([]);

const pageInfo = reactive({
  page: 0,
  size: 20,
  totalElements: 0,
  totalPages: 0,
});

const loading = reactive({
  list: false,
  detail: false,
});

/* --------------------------- Detail modal --------------------------- */

const showDetailModal = ref(false);
const detail = reactive({});

const duyetForm = reactive({
  lyDoTuChoi: "",
  lastActionApprove: true,
});

const huongXuLyForm = reactive({
  huongXuLy: "",
});

const thanhToanForm = reactive({
  soTienThucTe: null,
  hinhThucThanhToan: "CHUYEN_KHOAN",
  ghiChu: "",
  files: [],
});

const actionLoading = reactive({
  duyet: false,
  huongXuLy: false,
  thanhToan: false,
});

/* --------------------------- Lightbox ảnh --------------------------- */

const lightbox = reactive({
  visible: false,
  imgs: [],
  index: 0,
});

/* ------------------------ Computed helpers ------------------------- */

const danhMucFilterOptions = computed(() => {
  if (filters.loai === "CHI") return danhMucChi.value;
  if (filters.loai === "THU") return danhMucThu.value;
  return [...danhMucChi.value, ...danhMucThu.value];
});

const pageSummary = computed(() => {
  let tongChi = 0;
  let tongThu = 0;
  for (const it of items.value) {
    if (it.loai === "CHI") tongChi += toNumber(it.soTien);
    else if (it.loai === "THU") tongThu += toNumber(it.soTien);
  }
  return { tongChi, tongThu };
});

const hoaDonImages = computed(() => {
  if (!detail.dsAnhHoaDon) return [];
  return detail.dsAnhHoaDon.map((img) => img.url).filter(Boolean);
});

const thanhToanImages = computed(() => {
  if (!detail.dsAnhThanhToan) return [];
  return detail.dsAnhThanhToan.map((img) => img.url).filter(Boolean);
});

const canDuyet = computed(
  () => detail && detail.trangThai === "CHO_DUYET"
);

const canDatHuongXuLy = computed(
  () => detail && detail.trangThai === "DA_DUYET"
);

const canThanhToanNgay = computed(() => {
  if (!detail || detail.trangThai !== "DA_DUYET") return false;
  return detail.huongXuLy === "TRA_NONG" || detail.huongXuLy === "NOP_NGAY";
});

const huongXuLyOptionsForDetail = computed(() => {
  if (detail.loai === "CHI") {
    return [
      { value: "QUA_LUONG", label: "Qua lương (Cty nợ NV)" },
      { value: "TRA_NONG", label: "Trả nóng (Cty trả ngay)" },
    ];
  }
  if (detail.loai === "THU") {
    return [
      { value: "TRU_LUONG", label: "Trừ lương (NV nợ cty)" },
      { value: "NOP_NGAY", label: "Nộp lại ngay" },
    ];
  }
  return [];
});

/* ------------------------------ Utils ------------------------------ */

function toNumber(val) {
  if (val === null || val === undefined) return 0;
  if (typeof val === "number") return val;
  const n = Number(val);
  return Number.isNaN(n) ? 0 : n;
}

function formatCurrency(val) {
  const n = toNumber(val);
  return new Intl.NumberFormat("vi-VN", {
    style: "currency",
    currency: "VND",
    maximumFractionDigits: 0,
  }).format(n);
}

function formatDate(d) {
  if (!d) return "";
  const date = new Date(d);
  if (Number.isNaN(date.getTime())) return d;
  return date.toLocaleDateString("vi-VN");
}

function formatHinhThuc(hinhThuc) {
  switch (hinhThuc) {
    case "TIEN_MAT":
      return "Tiền mặt";
    case "CHUYEN_KHOAN":
      return "Chuyển khoản";
    default:
      return hinhThuc || "-";
  }
}

function badgeTrangThaiClass(st) {
  switch (st) {
    case "CHO_DUYET":
      return "badge-warning";
    case "DA_DUYET":
      return "badge-info";
    case "DA_THANH_TOAN":
      return "badge-success";
    case "DA_QUYET_TOAN":
      return "badge-primary";
    case "TU_CHOI":
      return "badge-danger";
    default:
      return "badge-light";
  }
}

function labelTrangThai(st) {
  switch (st) {
    case "CHO_DUYET":
      return "Chờ duyệt";
    case "DA_DUYET":
      return "Đã duyệt";
    case "DA_THANH_TOAN":
      return "Đã thanh toán";
    case "DA_QUYET_TOAN":
      return "Đã quyết toán lương";
    case "TU_CHOI":
      return "Từ chối";
    default:
      return st || "-";
  }
}

function badgeHuongXuLyClass(hx) {
  switch (hx) {
    case "QUA_LUONG":
      return "badge-info";
    case "TRA_NONG":
      return "badge-success";
    case "TRU_LUONG":
      return "badge-warning";
    case "NOP_NGAY":
      return "badge-success";
    default:
      return "badge-light";
  }
}

function labelHuongXuLy(hx, loai) {
  switch (hx) {
    case "QUA_LUONG":
      return "Qua lương";
    case "TRA_NONG":
      return "Trả nóng";
    case "TRU_LUONG":
      return "Trừ lương";
    case "NOP_NGAY":
      return "Nộp lại ngay";
    default:
      return hx || (loai === "CHI" ? "Hướng xử lý chi" : "Hướng xử lý thu");
  }
}

/* -------------------------- Load options --------------------------- */

async function loadPhongBanOptions() {
  try {
    const res = await api.get("/api/phong-ban/options");
    phongBanOptions.value = res.data?.data || [];
  } catch {
    toast.error("Không tải được danh sách phòng ban");
  }
}

async function loadNguoiDungOptions() {
  try {
    const params = {
      limit: 200,
    };
    if (filters.idPhongBan) {
      params.phongBanId = filters.idPhongBan;
    }
    const res = await api.get("/api/nguoi-dung/options", { params });
    nguoiDungOptions.value = res.data || [];
  } catch {
    toast.error("Không tải được danh sách nhân viên");
  }
}

async function loadDanhMucChi() {
  try {
    const res = await api.get("/api/thu-chi/danh-muc", {
      params: { loai: "CHI" },
    });
    danhMucChi.value = res.data || [];
  } catch {
    toast.error("Không tải được danh mục Chi");
  }
}

async function loadDanhMucThu() {
  try {
    const res = await api.get("/api/thu-chi/danh-muc", {
      params: { loai: "THU" },
    });
    danhMucThu.value = res.data || [];
  } catch {
    toast.error("Không tải được danh mục Thu");
  }
}

/* --------------------------- Load list ----------------------------- */

async function loadList() {
  loading.list = true;
  try {
    const params = {
      keyword: filters.keyword || undefined,
      loai: filters.loai || undefined,
      trangThai: filters.trangThai || undefined,
      huongXuLy: filters.huongXuLy || undefined,
      tuNgay: filters.tuNgay || undefined,
      denNgay: filters.denNgay || undefined,
      idPhongBan: filters.idPhongBan || undefined,
      idNguoiTao: filters.idNguoiDung || undefined,
      idDanhMuc: filters.idDanhMuc || undefined,
      page: pageInfo.page,
      size: pageInfo.size,
    };

    const res = await api.get("/api/thu-chi/admin", { params });
    const page = res.data;
    items.value = page.content || [];
    pageInfo.totalElements = page.totalElements || 0;
    pageInfo.totalPages = page.totalPages || 1;
    pageInfo.page = page.number || 0;
  } catch (e) {
    console.error(e);
    toast.error("Lỗi khi tải danh sách phiếu Thu Chi");
  } finally {
    loading.list = false;
  }
}

/* --------------------------- Filters UI ---------------------------- */

function onSearch() {
  pageInfo.page = 0;
  loadList();
}

function onResetFilters() {
  filters.keyword = "";
  filters.loai = "";
  filters.trangThai = "";
  filters.huongXuLy = "";
  filters.tuNgay = "";
  filters.denNgay = "";
  filters.idPhongBan = null;
  filters.idNguoiDung = null;
  filters.idDanhMuc = null;
  pageInfo.page = 0;
  loadNguoiDungOptions();
  loadList();
}

function changePage(newPage) {
  if (newPage < 0 || newPage >= pageInfo.totalPages) return;
  pageInfo.page = newPage;
  loadList();
}

/* --------------------------- Detail logic -------------------------- */

async function openDetail(row) {
  if (!row || !row.id) return;
  showDetailModal.value = true;
  loading.detail = true;
  Object.keys(detail).forEach((k) => delete detail[k]);
  duyetForm.lyDoTuChoi = "";
  huongXuLyForm.huongXuLy = "";
  thanhToanForm.soTienThucTe = null;
  thanhToanForm.ghiChu = "";
  thanhToanForm.files = [];

  try {
    const res = await api.get(`/api/thu-chi/admin/${row.id}`);
    Object.assign(detail, res.data || {});

    const defaultMoney =
      detail.soTienThucTe != null ? detail.soTienThucTe : detail.soTien;
    thanhToanForm.soTienThucTe = toNumber(defaultMoney) || null;
    thanhToanForm.hinhThucThanhToan = "CHUYEN_KHOAN";
    thanhToanForm.ghiChu = detail.ghiChuThanhToan || "";
  } catch (e) {
    console.error(e);
    toast.error("Không tải được chi tiết phiếu");
    closeDetail();
  } finally {
    loading.detail = false;
  }
}

function closeDetail() {
  showDetailModal.value = false;
}

/* --------------------------- Duyệt / Từ chối --------------------------- */

async function onDuyet(isApprove) {
  if (!detail.id) return;
  if (!canDuyet.value) {
    toast.warning("Chỉ có thể duyệt khi phiếu đang ở trạng thái CHỜ DUYỆT");
    return;
  }
  if (!isApprove && !duyetForm.lyDoTuChoi.trim()) {
    toast.error("Vui lòng nhập lý do từ chối");
    return;
  }
  duyetForm.lastActionApprove = isApprove;
  actionLoading.duyet = true;
  try {
    const body = {
      duyet: isApprove,
      lyDoTuChoi: isApprove ? null : duyetForm.lyDoTuChoi.trim(),
    };
    const res = await api.post(`/api/thu-chi/admin/${detail.id}/duyet`, body);
    Object.assign(detail, res.data || {});
    toast.success(isApprove ? "Đã duyệt phiếu" : "Đã từ chối phiếu");
    await loadList();
  } catch (e) {
    console.error(e);
    toast.error("Lỗi khi gửi duyệt / từ chối phiếu");
  } finally {
    actionLoading.duyet = false;
  }
}

/* --------------------------- Hướng xử lý --------------------------- */

async function onDatHuongXuLy() {
  if (!detail.id) return;
  if (!canDatHuongXuLy.value) {
    toast.warning("Chỉ có thể chọn hướng xử lý khi phiếu đã được duyệt");
    return;
  }
  if (!huongXuLyForm.huongXuLy) {
    toast.error("Vui lòng chọn hướng xử lý");
    return;
  }
  actionLoading.huongXuLy = true;
  try {
    const body = {
      huongXuLy: huongXuLyForm.huongXuLy,
    };
    const res = await api.post(
      `/api/thu-chi/admin/${detail.id}/huong-xu-ly`,
      body
    );
    Object.assign(detail, res.data || {});
    toast.success("Đã cập nhật hướng xử lý");
    await loadList();
  } catch (e) {
    console.error(e);
    toast.error("Lỗi khi cập nhật hướng xử lý");
  } finally {
    actionLoading.huongXuLy = false;
  }
}

/* --------------------------- Thanh toán ngay --------------------------- */

function onFilesChange(e) {
  const files = e.target.files;
  thanhToanForm.files = files ? Array.from(files) : [];
}

async function onThanhToanNgay() {
  if (!detail.id) return;
  if (!canThanhToanNgay.value) {
    toast.warning("Không thể xác nhận thanh toán ở trạng thái hiện tại");
    return;
  }

  const soTien =
    thanhToanForm.soTienThucTe && thanhToanForm.soTienThucTe > 0
      ? thanhToanForm.soTienThucTe
      : toNumber(detail.soTien);

  if (!thanhToanForm.hinhThucThanhToan) {
    toast.error("Vui lòng chọn hình thức thanh toán");
    return;
  }
  if (!soTien || soTien <= 0) {
    toast.error("Số tiền thanh toán/nộp lại không hợp lệ");
    return;
  }

  actionLoading.thanhToan = true;

  try {
    let urls = [];
    if (thanhToanForm.files && thanhToanForm.files.length) {
      const fd = new FormData();
      thanhToanForm.files.forEach((f) => fd.append("files", f));
      fd.append("folderName", "thu-chi-thanh-toan");
      const uploadRes = await api.post("/api/images/upload", fd, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      const list = uploadRes.data || [];
      // Ưu tiên location, fallback url
      urls = list
        .map((x) => x.location || x.url)
        .filter(Boolean);
    }

    const body = {
      soTienThucTe: soTien,
      hinhThucThanhToan: thanhToanForm.hinhThucThanhToan,
      ghiChuThanhToan: thanhToanForm.ghiChu || null,
      dsAnhThanhToanUrl: urls,
    };

    const res = await api.post(
      `/api/thu-chi/admin/${detail.id}/thanh-toan-ngay`,
      body
    );
    Object.assign(detail, res.data || {});
    toast.success(
      detail.loai === "CHI"
        ? "Đã xác nhận trả nóng cho nhân viên"
        : "Đã xác nhận nhân viên nộp lại"
    );
    await loadList();
    thanhToanForm.files = [];
  } catch (e) {
    console.error(e);
    toast.error("Lỗi khi xác nhận thanh toán/nộp lại");
  } finally {
    actionLoading.thanhToan = false;
  }
}

/* --------------------------- Lightbox --------------------------- */

function openLightbox(url) {
  lightbox.imgs = [url];
  lightbox.index = 0;
  lightbox.visible = true;
}

/* --------------------------- Lifecycle --------------------------- */

onMounted(async () => {
  await Promise.all([
    loadPhongBanOptions(),
    loadNguoiDungOptions(),
    loadDanhMucChi(),
    loadDanhMucThu(),
  ]);
  await loadList();
});
</script>

<style scoped>
.filter-row .form-label {
  font-size: 0.8rem;
  font-weight: 500;
}

.mini-stat {
  border-radius: 0.75rem;
  box-shadow: 0 4px 12px rgba(15, 34, 58, 0.08);
}

.bg-soft-danger {
  background-color: rgba(220, 53, 69, 0.07);
}

.bg-soft-success {
  background-color: rgba(40, 167, 69, 0.07);
}

/* Modal override to work without Bootstrap JS */
.modal {
  background: rgba(0, 0, 0, 0.25);
}
.modal-dialog {
  max-width: 1100px;
}
.modal-content {
  border-radius: 0.75rem;
}
.modal-header,
.modal-footer {
  padding: 0.75rem 1rem;
}
.modal-body {
  padding: 0.75rem 1rem;
}

/* Responsive tweaks */
@media (max-width: 767.98px) {
  .card-body {
    padding: 0.75rem;
  }
  .table {
    font-size: 0.8rem;
  }
}
</style>
